export const productlist=[
    {
        name:'Converse Chuck Taylor All Star Double Stack Lift My Story',
        img:'/Imgs/s1.jpg',
        info:'Converse My Story gây ấn tượng với các thiết kế độc đáo cùng họa tiết “My Story” graphics được in liền mạch đầy ấn tượng. Trên nền giày Canvas, các con chữ như nhảy múa, nối đuôi nhau một cách bất tận, mang đến phong cách mới lạ, thú vị cho người mang. Đặc biệt hơn với thiết kế Double-Stack Sole còn cho các nàng thỏa sức hack dáng để diện các set đồ thời trang, cá tính hơn.',
        material:'Chất liệu: Canvas',
        cost:'1.620.000đ',
        costNum:1620000,
    },
    {
        name:'Converse Chuck Taylor All Star 1970s Archive Paint Splatter',
        img:'/Imgs/s2.jpg',
        info:'Chào hè bằng những thiết kế Converse Archive Paint Splatter, thương hiệu bóng rổ đình đám đã có dịp chinh phục các bạn trẻ đang hướng đến sự mới lạ và phong cách cá tính. Ứng dụng xu hướng Paint Splatter với hình ảnh những tia sơn màu được phun một cách không cần trật tự lên bản in cho thiết kế mới, Converse mang đến item đầy sắc màu để bạn “hết mình” với style trẻ trung, năng động nhất.',
        material:'Chất liệu: Canvas',
        cost:'1.800.000đ',
        costNum:1800000,
    },
    {
        name:'Vans MN Skate Old Skool',
        img:'/Imgs/s3.jpg',
        info:'Hình mẫu Old Skool cổ điển tái xuất trong phiên bản Vans Skate Old Skool với hàng loạt cải tiến mang tính đột phá cho dòng giày trượt ván. Tái sinh bằng một cái tên mới, mẫu giày không chỉ gây ấn tượng bởi những chi tiết nhỏ nhất được thay đổi, mà còn làm dậy sóng làng skaters với công nghệ đỉnh cao tích hợp trong miếng lót Duracap, đệm lót PopCush hay keo cao su SickStick, mang lại sự thoải mái và tiện nghi đối đa cho các skate-thủ.',
        material:'Chất liệu: Canvas',
        cost:'1.980.000đ',
        costNum:1980000,
    },
    {
        name:'Vans UA SK8-Hi Racer Edge',
        img:'/Imgs/s4.jpg',
        info:'Vans SK8-Hi Racer Edge nổi bật với thiết kế những đường sọc đặc trưng, mô tả sống động biểu tượng của tốc độ bên cạnh là logo thương hiệu thu hút. Vans Racer Edge hỗ trợ cho các tay trượt ván một cách linh hoạt, mạnh mẽ.',
        material:'Chất liệu: 54% Leather; 46% Rubber Plastic',
        cost:'1.710.000đ',
        costNum:1710000,
    },
    {
        name:'Converse Chuck Taylor All Star 1970s Wolf Grey',
        img:'/Imgs/s5.jpg',
        info:'Một phiên bản Converse Chuck 70 cực bắt mắt với gam màu Wolf Grey trendy đậm chất high-fashion, cho bạn một outlook cực tươi mới, thu hết mọi ánh nhìn khi xuống phố. Kiểu dáng cổ điển mang tính di sản đi cùng những đường khâu tỉ mỉ tạo nên một sản phẩm vô cùng bền bỉ, chắc chắn. Bên cạnh đó là những nâng cấp được đưa vào, từ đệm lót OrthoLite đến đế ngà dày dặn được phủ bóng, chắc chắn sẽ cho bạn những trải nghiệm tuyệt vời khi “trên chân” một sản phẩm “điểm 10 chất lượng”.',
        material:'Chất liệu: Canvas',
        cost:'1.800.000đ',
        costNum:1800000,
    },
    {
        name:'Converse Chuck Taylor All Star Platform Valentine',
        img:'/Imgs/s6.jpg',
        info:'Trở lại vào một dịp rất đặc biệt trong năm bằng BST Converse Valentine’s Day, các nhà thiết kế đã truyền đi thông điệp yêu thương qua lời nhắn “Made With Love” được thêu nổi bật trên thân giày. Thiết kế đế Platform dày dặn cực “yêu” cho nàng tôn dáng một cách đầy tinh tế. Kiểu dáng đặc trưng cùng chất liệu cao cấp, bền bỉ mang đến một item mà các bạn nữ không thể thiếu khi sánh vai cùng “người ấy”.',
        material:'Chất liệu: Canvas',
        cost:'1.620.000đ',
        costNum:1620000,
    },
    {
        name:'Vans x MoMA UA ComfyCush Old Skool',
        img:'/Imgs/s7.jpg',
        info:'Trở lại vào một dịp rất đặc biệt trong năm bằng BST Converse Valentine’s Day, các nhà thiết kế đã truyền đi thông điệp yêu thương qua lời nhắn “Made With Love” được thêu nổi bật trên thân giày. Thiết kế đế Platform dày dặn cực “yêu” cho nàng tôn dáng một cách đầy tinh tế. Kiểu dáng đặc trưng cùng chất liệu cao cấp, bền bỉ mang đến một item mà các bạn nữ không thể thiếu khi sánh vai cùng “người ấy”.',
        material:'Chất liệu: 56.2% Leather; 43.8% Textile',
        cost:'1.620.000đ',
        costNum:1620000,
    },
    {
        name:'Vans x MoMA UA ComfyCush Old Skool',
        img:'/Imgs/s8.jpg',
        info:'Vans x MoMA ComfyCush Old Skool là sản phẩm kết hợp của hãng giày Vans và Viện Bảo tàng Nghệ thuật Hiện đại (MoMA), mang đến sự đột phá trong thiết kế bên ngoài cũng như kết cấu bên trong. Chất liệu upper làm từ vải textile với họa tiết Checkerboard được biến tấu màu sắc độc đáo. Công nghệ ComfyCush hiện đại giúp giảm thiểu trọng lượng và đem lại cảm giác êm ái, nhẹ nhàng khi mang.',
        material:'Chất liệu: 89.6% Textile; 10.4% Rubber Plastic',
        cost:'2.250.000đ',
        costNum:2250000,
    },
    {
        name:'Converse Chuck Taylor All Star Gamer Low-Top',
        img:'/Imgs/s9.jpg',
        info:'Mẫu giày Converse Kid Gamer Low Top sử dụng họa tiết đa màu sắc vui nhộn, được lấy cảm hứng từ những trò chơi điện tử ăn khách từ thập kỷ trước, được trẻ em trên khắp thế giới yêu thích. Thiết kế mang phong cách đơn giản nhưng cũng vô cùng thu hút, sẽ là một món quà đặc biệt để làm các bạn nhỏ bất ngờ.',
        material:'Chất liệu: 89.6% Textile; 10.4% Rubber Plastic',
        cost:'2.250.000đ',
        costNum:2250000,
    },
    {
        name:'Vans x MoMA UA ComfyCush Old Skool',
        img:'/Imgs/s10.jpg',
        info:'Mẫu giày Converse Kid Gamer Low Top sử dụng họa tiết đa màu sắc vui nhộn, được lấy cảm hứng từ những trò chơi điện tử ăn khách từ thập kỷ trước, được trẻ em trên khắp thế giới yêu thích. Thiết kế mang phong cách đơn giản nhưng cũng vô cùng thu hút, sẽ là một món quà đặc biệt để làm các bạn nhỏ bất ngờ.',
        material:'Chất liệu: 89.6% Textile; 10.4% Rubber Plastic',
        cost:'2.250.000đ',
        costNum:2250000,
    },
    {
        name:'Vans UA Old Skool Style 36 SE Bikes',
        img:'/Imgs/s11.jpg',
        info:'Kỷ niệm những năm tháng đồng hành cùng các BMX Riders trên những chặng đua đầy thử thách, Vans x SE Bikes đã hợp tác để cho ra mắt những mẫu giày dành cho bộ môn đua xe đạp địa hình. Thiết kế mang đậm tính thể thao đường phố với tên của các dòng xe đạp biểu tượng ở midsole, kết hợp cùng kết cấu tiện nghi, linh hoạt nhất, mẫu giày hứa hẹn sẽ đáp ứng được những yêu cầu khắt khe trong vận động để bạn hết mình cho một ngày dài đầy thử thách.',
        material:'Chất liệu: 59.95% Textile, 40.05% Leather',
        cost:'2.070.000đ',
        costNum:2070000,
    },
    {
        name:'Converse Chuck Taylor All Star 1970s Archive Paint Splatter',
        img:'/Imgs/s12.jpg',
        info:'Chào hè bằng những thiết kế Converse Archive Paint Splatter, thương hiệu bóng rổ đình đám đã có dịp chinh phục các bạn trẻ đang hướng đến sự mới lạ và phong cách cá tính. Ứng dụng xu hướng Paint Splatter với hình ảnh những tia sơn màu được phun một cách không cần trật tự lên bản in cho thiết kế mới, Converse mang đến item đầy sắc màu để bạn “hết mình” với style trẻ trung, năng động nhất.',
        material:'Chất liệu: 59.95% Textile, 40.05% Leather',
        cost:'1.710.000đ',
        costNum:1710000,
    },
]